package com.parmartechnologies.business.feature.businessType.viewModel

import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.core.feature.businessType.model.BusinessType
import com.parmartechnologies.core.feature.businessType.network.BusinessTypeRequest
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.business.feature.business.handler.BusinessHandler
import com.parmartechnologies.business.feature.businessType.handler.BusinessTypeHandler
import com.parmartechnologies.business.feature.businessType.network.BusinessTypeNetwork
import com.parmartechnologies.business.feature.businessType.repository.BusinessTypeRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class BusinessTypeViewModel :
    AppViewModel() {
    val repository: BusinessTypeRepository = BusinessTypeHandler.shared().repository
    val allBusinessType: StateFlow<List<BusinessType>>
        get() = repository.allBusinessTypeLiveData

    val businessType: StateFlow<BusinessType?>
        get() = repository.businessType

    fun retrieve(completion: ((String?) -> Unit) = {}) {
        val business = BusinessHandler.shared().repository.myBusiness
        val request = BusinessTypeRequest(business.value._id)
        BusinessTypeNetwork().retrieve(request) {result,response->
            if (!result?.payload.isNullOrEmpty()) {
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    repository.allBusinessTypeLiveData.emit(result!!.payload)
                    DatabaseCollection().insertAll(result.payload,BusinessType.serializer())
                    completion(response)
                }
            } else {
                completion(response)
            }
        }
    }

    fun setSelectedBusinessType(type: BusinessType) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            repository.businessTypeState.emit(type)
        }
    }

    fun load(){
        DatabaseCollection().findAll(mapOf(),BusinessType.serializer()){ allTypes->
            scope.launch {
                if(allTypes.isEmpty()){
                    retrieve {  }
                }else{
                    repository.allBusinessTypeLiveData.emit(allTypes)
                }
            }
        }
    }

    fun findById(id: String, completion: ((BusinessType) -> Unit)) {
        if (allBusinessType.value.isEmpty()) {
            retrieve {
                allBusinessType.value.forEach { type ->
                    if (type._id == id) {
                        completion(type)
                    }
                }
            }
        } else {
            allBusinessType.value.forEach { type ->
                if (type._id == id) {
                    completion(type)
                }
            }
        }
    }
}